import { useEffect, useState } from "react"
import * as React from "react"
import { PaginationType } from "@/types"
import { useQuery } from "@tanstack/react-query"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { useReactToPrint } from "react-to-print"

import { MeterReaderZoneType } from "@/types/meter"
import { canViewThisPage } from "@/lib/api/auth"
import { getMeterReaderZone } from "@/lib/api/billing"
import { getMeterReader } from "@/lib/api/meter"
import { Button } from "@/components/ui/button"
import { DataTable } from "@/components/data-table"
import { Header } from "@/components/header"
import { Icons } from "@/components/icons"
import { meterReaderColumns } from "@/components/table/columns/meter-reader-columns"
import { ExportOperationModal } from "@/components/table/operations/export-operations"

import { AddMeterReaderPage } from "./add"

export const Route = createFileRoute(
  "/_home/meter-connection-settings/meter-reader/",
)({
  beforeLoad: () => {
    if (canViewThisPage("himo_billing.view_meterreader")) {
      return
    }

    return redirect({ to: "/access-denied" })
  },
  component: MeterReaderPage,
})

function MeterReaderPage() {
  const [showExportModal, setShowExportModal] = React.useState<boolean>(false)
  const [defaultPage, setDefaultPage] = useState<number>(10)
  const [page, setPage] = useState<number>(1)
  const [search, setSearch] = useState<string>("")
  const [zones, setZones] = useState<number[]>([])
  const [nextPageUrl, setNextPageUrl] = useState<string | null>(null)
  const [prevPageUrl, setPrevPageUrl] = useState<string | null>(null)
  const {
    data: meterReaderDetails,
    isError,
    isLoading,
  } = useQuery<PaginationType<MeterReaderZoneType>>({
    queryKey: ["meterReaderDetails", defaultPage, page, search, zones],
    queryFn: () => getMeterReaderZone(defaultPage, page, search, zones),
  })

  useEffect(() => {
    if (meterReaderDetails) {
      setNextPageUrl(meterReaderDetails.next)
      setPrevPageUrl(meterReaderDetails.previous)
    }
  }, [meterReaderDetails])

  const contentRef = React.useRef<HTMLDivElement>(null)
  const reactToPrintFn = useReactToPrint({ contentRef })
  return (
    <div className="space-y-4 p-4">
      <Header>Meter Reader</Header>
      <div ref={contentRef} className="print:p-2">
        <DataTable
          columns={meterReaderColumns}
          data={meterReaderDetails?.results ?? []}
          search={{
            //field: "name",
            label: "zone",
            value: search,
            onChange: setSearch,
          }}
          isLoading={isLoading}
          isError={isError}
          defaultPage={defaultPage}
          setDefaultPage={setDefaultPage}
          nextPageUrl={nextPageUrl}
          prevPageUrl={prevPageUrl}
          page={page}
          setPage={setPage}
          totalCount={meterReaderDetails?.count}
          //tableTitle="Meter Reader"
          zones={zones}
          setZones={setZones}
        >
          <div className="flex w-full justify-end">
            <AddMeterReaderPage />
            <Button className="mx-1" onClick={(e) => reactToPrintFn()}>
              <Icons.download />
              Print Meter Reader
            </Button>
            <ExportOperationModal
              tableData={meterReaderDetails?.results ?? [{}]}
              fileName="Meter Reader"
              showExportModal={showExportModal}
              setShowExportModal={setShowExportModal}
            />
          </div>
        </DataTable>
      </div>
    </div>
  )
}
